import * as React from 'react';
import { SVGProps } from 'react';

const IconIntroductionSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11 1h-1v10h1V1zM1 6.501h6.293L4.928 8.86l.708.707L9.208 6 5.669 2.46l-.707.707L7.293 5.5H1v1z" />
  </svg>
);
export default IconIntroductionSizeXs;
